// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","BrochureButton":"BrochureDownload_BrochureButton__WKJMH"};